import  React, { useState } from 'react';
import { MdAddBox } from "react-icons/md";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";

export default function FormSelectList(props) {
   const [showOnlySelected, setShowOnlySelected] = useState(
      props.defaultShowOnlySelected !== undefined ? !!props.defaultShowOnlySelected : true
   );
   var label = props.label || props.field;
   var field = props.field || props.label;
   const options = props.sort ? props.options.sort(props.sort) : props.options || [];

   if (props &&
      props.formObject &&
      props.formObject.object &&
      props.formObject.object.constructor === Object && Object.keys(props.formObject.object).length > 0 &&
      !props.formObject.object.hasOwnProperty(field)) {
      console.error("The object specified does not have a " + field + " property");
   }

   const myClick = (value, e) => {
      props.formObject.onChange(value, field, 'FormSelectList', e);
   }

   // Make sure we have valid keys for React lists to prevent duplicate key errors
   const validateUniqueKeys = () => {
      if (!props.options || !Array.isArray(props.options)) return;
      
      const seenKeys = new Set();
      props.options.forEach((item, index) => {
         // Use ID, id, Key, or index as fallback
         const key = item.ID || item.id || item.Key || index;
         if (key === undefined) {
           console.error("Missing key for item at index " + index);
         } else if (seenKeys.has(key)) {
           console.error("Duplicate Key value found: " + key);
         } else {
           seenKeys.add(key);
         }
      });
   };
   
   // Run validation in development only
   if (process.env.NODE_ENV !== 'production') {
      validateUniqueKeys();
   }

   // Get all rendered items up front to determine their selection state
   const renderedItems = options.map(option => ({
      option,
      rendered: props.renderItem(option, myClick)
   }));
   
   // Filter options based on showOnlySelected state
   const filteredItems = showOnlySelected 
      ? renderedItems.filter(item => item.rendered.props && item.rendered.props.selected)
      : renderedItems;
   
   const toggleViewMode = () => {
      setShowOnlySelected(!showOnlySelected);
   };

   return (
      <div className="field FormSelectList">
         <label>{label}</label>
         <div className="listControls">
            {props.onAdd ? (
               <span className="addIcon"><MdAddBox onClick={e => { props.onAdd() }} title="Add new item" /></span>
            ) : null}
            {/* {props.onToggleSelect ? (
               <span className="toggleIcon" onClick={props.onToggleSelect} title={showOnlySelected ? "Select All" : "Deselect All"}>
                  {showOnlySelected ? "Select All" : "Deselect All"}
               </span>
            ) : null} */}
            <span className="viewToggleIcon" onClick={toggleViewMode} title={showOnlySelected ? "Show all items" : "Show only selected items"}>
               {showOnlySelected ? <FiChevronsDown /> : <FiChevronsUp />}
            </span>
         </div>
         <ul className="selectionList">
            {filteredItems.length > 0 ? (
               filteredItems.map((item, index) => {
                  // Ensure each rendered item has a unique key
                  const key = item.option.ID || item.option.id || item.option.Key || index;
                  return React.cloneElement(item.rendered, { key });
               })
            ) : (
               <li className="noItems">{showOnlySelected ? "No items selected" : "No items available"}</li>
            )}
         </ul>
      </div>
   );
}